/** Keep PNG/WebP alpha through the editor's resize before uploading. */
export async function shrinkStudioImage(
  file: File,
  maxEdge = 720
): Promise<string> {
  const bitmap = await createImageBitmap(file)
  try {
    const scale = Math.min(1, maxEdge / Math.max(bitmap.width, bitmap.height))
    const canvas = document.createElement('canvas')
    canvas.width = Math.max(1, Math.round(bitmap.width * scale))
    canvas.height = Math.max(1, Math.round(bitmap.height * scale))
    const context = canvas.getContext('2d')
    if (!context) throw new Error('이미지를 처리할 수 없어요.')
    context.drawImage(bitmap, 0, 0, canvas.width, canvas.height)
    // JPEG has no alpha channel; encoding a transparent canvas as JPEG turns
    // its empty background black. PNG also preserves partially transparent edges.
    return canvas.toDataURL(
      file.type === 'image/jpeg' ? 'image/jpeg' : 'image/png',
      0.85
    )
  } finally {
    bitmap.close()
  }
}
